<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome Completo"
            class="col-md-12"
          >
            <b-form-input
              v-model="form.nomeCompleto"
              disabled
            />
          </b-form-group>
        </b-row>
        <b-row>
          <b-col
            v-if="form.nomeCompleto !== ''"
            cols="12"
          >
            <dados-smtp
              :email="form.smtpEmail"
              :senha="form.smtpSenha"
              :user-id="form.id"
              :validado="form.validado"
              :usuario-validou="form.usuarioValidou"
              :data-validacao="form.dataValidacao"
              :nao-editar-email="true"
              :logado-google="form.logadoGoogle"
              :usar-google="form.usarGoogle"
              @input="setDadosSmtp"
              @email-google="iniciarLoginAutenticacao()"
              @sign-out="signOutGoogle($event)"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import {
  required,
} from '@validations'
import { initClientGoogle } from '@/shared/mixins/login-google/login-google'
import api from '@/app-modulo/comuns/usuario-interno/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Perfil',
  components: {
    CadastroBase,
    DadosSmtp: () => import('@/shared/components/dados-smtp/DadosSmtp.vue'),
  },
  data() {
    return {
      required,
      form: {
        id: 0,
        nomeCompleto: '',
        smtpEmail: '',
        smtpSenha: '',
        validado: null,
        usuarioValidou: '',
        dataValidacao: '',
      },
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getPerfil()
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        api.salvarPerfil(this.form.smtpSenha)
          .then(() => {
            resolve('Perfil atualizado com sucesso')
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    setDadosSmtp(dados) {
      this.form.smtpEmail = dados.smtpEmail
      this.form.smtpSenha = dados.smtpSenha
      this.form.validado = dados.validado
      this.form.usuarioValidou = dados.usuarioValidou
      this.form.dataValidacao = dados.dataValidacao
    },
    iniciarLoginAutenticacao() {
      api.getClientGoogle()
        .then(payload => {
          initClientGoogle(this.loginGoogle, payload.data)
        })
    },
    loginGoogle(tokenResponse) {
      api.autenticarGoogle(this.form.id, tokenResponse.code, this.form.smtpEmail)
        .then(payload => {
          this.form.refreshToken = payload.data.refreshToken
          this.form.smtpEmail = payload.data.smtpEmail
          this.form.logadoGoogle = true
          this.$sucesso('Conectado com sucesso')
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    signOutGoogle() {
      api.logOutGoogle(this.form.id)
        .then(payload => {
          if (payload.data) {
            this.form.refreshToken = null
            this.form.logadoGoogle = false
            this.$sucesso('Desconectado da conta')
          } else {
            this.$erro('Não foi possivel desconectar da conta')
          }
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
  },
}
</script>
